import {getFormData} from '../../../utilities/helper/formDataConvertor';
import request from '../../axios';

const PostStory = async (payload: IPostStory) => {
  await request.post(
    'api/v2/store/story-posts',
    getFormData(payload as unknown as {[name: string]: string | Blob}),
  );
};

export default PostStory;
